import React from "react";
import { FiBriefcase, FiFileText, FiUsers, FiPackage } from "react-icons/fi";

const ENTITY_CONFIG = {
  lead: { icon: FiBriefcase, label: "Lead", className: "biz-context-badge--lead" },
  request: { icon: FiFileText, label: "Request", className: "biz-context-badge--request" },
  client: { icon: FiUsers, label: "Client", className: "biz-context-badge--client" },
  order: { icon: FiPackage, label: "Order", className: "biz-context-badge--order" },
};

const BusinessContextBadge = ({ linkedEntity, onClick }) => {
  if (!linkedEntity?.entityType) return null;

  const config = ENTITY_CONFIG[linkedEntity.entityType] || ENTITY_CONFIG.lead;
  const Icon = config.icon;

  return (
    <button
      type="button"
      className={`biz-context-badge ${config.className}`}
      onClick={onClick}
      title={`View ${config.label} context`}
    >
      <Icon size={11} />
      <span>{linkedEntity.entityName || linkedEntity.entityId}</span>
      {linkedEntity.entityMeta?.status && (
        <span className="biz-context-badge__status">{linkedEntity.entityMeta.status}</span>
      )}
    </button>
  );
};

export default BusinessContextBadge;
